// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1qRt7","title":"ClientReferral_title__AWSHf","itemText":"ClientReferral_itemText__3ykzX"};